// Default entry point for client scripts
// Automatically generated
// Please avoid from modifying to much...
import * as ReactDOM from "react-dom";
import * as React from "react";
export const render = (type: any, element: HTMLElement) => {
    ReactDOM.render(React.createElement(type, {}), element);
};
// Automatically added for the myDefaultTab1Tab tab
// export * from "./myDefaultTab1Tab/MyDefaultTab1Tab";

// manually added by ash
export * from "./teamsTabs/tabCpbxDirectory/TabCpbxDirectory";
export * from "./teamsTabs/tabCpbxSettings/TabCpbxSettings";
export * from "./teamsTabs/tabFaq/TabFaq";
export * from "./teamsTabs/tabAppSettings/TabAppSettings";

// not really a tab but a component which could be shown by each tab
export * from "./teamsTabs/tabAppInfo/TabAppInfo";

// could be removed later - currently just for testing purpose
export * from "./teamsTabs/tabDevTest/TabDevTest";
